import { createBrowserHistory } from "history/cjs/history";

const history = createBrowserHistory();

export default history;